import { render, staticRenderFns } from "./transaction-info.vue?vue&type=template&id=1b99640c&scoped=true"
import script from "./transaction-info.vue?vue&type=script&lang=js"
export * from "./transaction-info.vue?vue&type=script&lang=js"
import style0 from "./transaction-info.vue?vue&type=style&index=0&id=1b99640c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b99640c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pre-ops-admin 管理后台-预发布环境/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b99640c')) {
      api.createRecord('1b99640c', component.options)
    } else {
      api.reload('1b99640c', component.options)
    }
    module.hot.accept("./transaction-info.vue?vue&type=template&id=1b99640c&scoped=true", function () {
      api.rerender('1b99640c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/express/components/transaction-info.vue"
export default component.exports